import { useLang } from 'hooks/lang';

import { FullProject, projectStatusConfig } from 'entities';

import { Column, Row, Tag, Tooltip } from 'components/Blocks';
import { CirclePlayIcon, UsersIcon } from 'components/Icons';

import { ProjectName } from './Name';

import { FreshdeskTicketTag, ProjectTypeTag } from 'pages/Projects/components';
import { TeamTag } from '../../../TeamTag';

import { formatDate } from 'utils/date';
import { useProjectOption } from '../../options';

interface Props {
  project: FullProject;
}

export function ProjectTitle({ project }: Props) {
  const { t } = useLang();

  const changeTeam = useProjectOption('CHANGE_TEAM');

  return (
    <Column gap="2">
      <ProjectName />

      <Row gap="2" alignItems="stretch" flexWrap="wrap">
        <FreshdeskTicketTag ticket={project.ticket} />

        <ProjectTypeTag projectType={project.type} />

        <TeamTag
          team={project.teamResponsible}
          round
          type="filled"
          className="text-background"
          action={changeTeam.isEnabled ? changeTeam.action : undefined}
          icon={<UsersIcon size={16} />}
        />

        {project.startedAt && (
          <Tooltip content={t('started-at')} ensurePresence>
            <Tag
              color={projectStatusConfig.started.color}
              className="text-xs"
              name={
                <>
                  <CirclePlayIcon size={14} />
                  {formatDate(project.startedAt)}
                </>
              }
            />
          </Tooltip>
        )}
      </Row>
    </Column>
  );
}
